import React from 'react';

export default function ComingSoonView() {
  return (<h1>Coming Soon!</h1>);
}
